import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { LoginAlertIcon, AppLogoIcon } from "../../icons";
import "./LoginPage.scss";

function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate("/dashboard", { replace: true });
      return;
    }
    if (!auth.isLoading && !auth.activeNavigator && !auth.error && !hasRedirected.current) {
      hasRedirected.current = true;
      auth.signinRedirect();
    }
  }, [auth, auth.isAuthenticated, auth.isLoading, auth.activeNavigator, auth.error, navigate]);

  if (auth.isLoading) {
    return (
      <div className="login-root">
        <div className="login-card">
          <div className="login-spinner" />
          <p className="login-status">Loading…</p>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="login-root">
        <div className="login-card login-card--error">
          <div className="login-error-icon">
            <LoginAlertIcon size={40} />
          </div>
          <h2 className="login-title">Authentication Error</h2>
          <p className="login-error-msg">{auth.error.message}</p>
          <button
            className="login-retry-btn"
            onClick={() => {
              // Clear BOTH storages so no stale OIDC state keys remain.
              // We also force redirect_uri to the current origin so that
              // a misconfigured env var cannot send the user to the wrong env.
              sessionStorage.clear();
              localStorage.clear();
              auth.signinRedirect({
                redirect_uri: window.location.origin + "/login",
              });
            }}
          >
            Retry Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-logo">
          <AppLogoIcon size={48} />
        </div>
        <h1 className="login-title">AV Sync</h1>
        <p className="login-status">Redirecting to sign in…</p>
        <div className="login-spinner" />
      </div>
    </div>
  );
}

export default LoginPage;
